import React from "react"
import agentesDeCambio from "../assets/images/capacidades/agentes/agentes-de-cambio.png"
import responsabilidades from "../assets/images/capacidades/agentes/responsabilidades.png"
import gestionConocimiento from "../assets/images/capacidades/agentes/gestion-conocimiento.png"
import ideas from "../assets/images/capacidades/agentes/ideas.png"
import metodologia from "../assets/images/capacidades/agentes/metodologia.png"
import priorizarFiltrar from "../assets/images/capacidades/agentes/priorizar-filtrar.png"
import alineacionEstrategia from "../assets/images/capacidades/agentes/alineacion-estrategia.png"
import reto from "../assets/images/capacidades/agentes/reto.png"
import video from "../assets/images/capacidades/agentes/video.png"

export default [
  {
    titulo: "aGentes de cambio",
    img: agentesDeCambio,
  },
  {
    titulo: "Responsabilidades:",
    img: responsabilidades,
  },
  {
    titulo: "1. Anticiparse a las necesidades de la compañía.",
    subtitulo: "Anticiparse a las necesidades de la compañía.",
    descripcion:
      "Identificar retos y oportunidades en nuestros procesos  y la organización.",
    img: ideas,
  },
  {
    titulo: "2. Acompañar y dinamizar el modelo de Innovación innGenio.",
    subtitulo: "Acompañar y dinamizar el modelo de Innovación innGenio.",
    descripcion:
      "Facilitar la adopción de sus herramientas en los equipos de trabajo.",
    img: gestionConocimiento,
  },
  {
    titulo: "3. Aplicar metodologías creativas y novedosas.",
    subtitulo: "Aplicar metodologías creativas y novedosas.",
    descripcion:
      "Para la  solución de problemas, facilitando el hallazgo de ideas que generen alternativas para la consecución de los objetivos.",
    img: metodologia,
  },
  {
    titulo:
      "4. Apalancar y acelerar la implementación efectiva de las soluciones generadas.",
    subtitulo:
      "Apalancar y acelerar la implementación efectiva de las soluciones generadas.",
    descripcion:
      "Para los equipo de trabajo, se fomenta la persistencia frente al logro de los objetivos.",
    img: alineacionEstrategia,
  },
  {
    titulo: "Video aGentes de innovación",
    img: video,
    video: "https://jwp.io/s/U8m5ngsW",
  },
]
